import React from 'react';
import { useTranslation } from 'react-i18next';
import { currencyFormatNoSpace } from '../../utils/currency';

type PaymentTotalProps = {
  // In dollars.
  amount: number;
};

// The amount to be charged on a checkout screen, shown between the
// PaymentMethodSelector and the pay button.
export default function PaymentTotal({ amount }: PaymentTotalProps) {
  const [t] = useTranslation('global');

  return (
    <p className="instructions">
      {t('payments.total', { amount: currencyFormatNoSpace(amount) })}
    </p>
  );
}
